import { defineComponent as y, computed as o, useCssModule as C, openBlock as g, createBlock as h, resolveDynamicComponent as p, normalizeClass as $, withCtx as b, renderSlot as n } from "vue";
import B from "../../utils/mapClasses.mjs";
import { buildBooleanClass as k, responsiveModifyClass as w } from "../../utils/buildClass.mjs";
import e from "../../utils/propValidator.mjs";
import O from "./styles/CdrButton.module.scss.mjs";
import v from "../../../_virtual/_plugin-vue_export-helper.mjs";
const z = y({
  name: "CdrButton",
  props: {
    /**
     * Renders CdrButton as a <button> or <a> element. When using the value of <a>, this element renders as an anchor link.
     * @demoIgnore true
     * @values button, a
     */
    tag: {
      type: String,
      default: "button",
      validator: (t) => e(t, ["button", "a"])
    },
    /**
     * Sets the button type
     * @demoIgnore true
     * @values button, submit, reset
     */
    type: {
      type: String,
      default: "button",
      validator: (t) => e(t, ["button", "submit", "reset"])
    },
    /**
     * Modifies the style variant for this component
     * @demoSelectMultiple false
     * @values primary, secondary, sale, dark, link
     */
    modifier: {
      type: String,
      default: "primary",
      validator: (t) => e(t, ["primary", "secondary", "sale", "dark", "link"])
    },
    /**
     * Sets the button size; values can target responsive breakpoints. Example: `large@sm`.
     * @demoSelectMultiple false
     * @values small, medium, large
     */
    size: {
      type: String,
      default: "medium",
      validator: (t) => e(t, ["small", "medium", "large"])
    },
    /**
     * Sets button width to 100%. Setting this value to true will set the button width to 100% of the parent container. Use the 'fullWidth' prop with the 'size' prop to control top and bottom padding.
     */
    fullWidth: {
      type: [String, Boolean],
      default: !1,
      validator: (t) => typeof t == "string" ? e(t, ["@xs", "@sm", "@md", "@lg"], !1) : typeof t == "boolean"
    },
    /**
     * Renders an 'icon-only' button. When this value is true, it will override the size and 'responsiveSize' props. Can be used in conjunction with 'with-background'
     */
    iconOnly: {
      type: Boolean,
      default: !1
    },
    /**
     * Renders an 'icon-only' button with a background color and border. Must be used in conjunction with the 'iconOnly' prop.
     */
    withBackground: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, l) {
    const s = "cdr-button", a = o(() => t.tag === "button" ? t.type : null), i = o(() => `${s}--${t.modifier}`), r = o(() => !t.iconOnly && t.fullWidth && k(s, t.fullWidth, "full-width")), d = o(() => t.iconOnly ? `cdr-button--icon-only-${t.size}` : w(s, "", t.size)), u = o(() => l.slots["icon-left"] && l.slots.default && `${s}--has-icon-left`), f = o(() => l.slots["icon-right"] && l.slots.default && `${s}--has-icon-right`), c = o(() => t.iconOnly && `${s}--icon-only`), m = o(() => t.iconOnly && t.withBackground && `${s}--with-background`);
    return {
      style: C(),
      mapClasses: B,
      baseClass: s,
      buttonType: a,
      modifierClass: i,
      fullWidthClass: r,
      sizeClass: d,
      iconLeftClass: u,
      iconRightClass: f,
      iconOnlyClass: c,
      withBackgroundClass: m
    };
  }
});
function S(t, l, s, a, i, r) {
  return g(), h(p(t.tag), {
    class: $(t.mapClasses(t.style, t.baseClass, t.modifierClass, t.sizeClass, t.fullWidthClass, t.iconOnlyClass, t.iconLeftClass, t.iconRightClass, t.withBackgroundClass)),
    type: t.buttonType
  }, {
    default: b(() => [n(t.$slots, "icon-left"), n(t.$slots, "icon"), n(t.$slots, "default"), n(t.$slots, "icon-right")]),
    _: 3
  }, 8, ["class", "type"]);
}
const W = {
  $style: O
}, j = /* @__PURE__ */ v(z, [["render", S], ["__cssModules", W]]);
export {
  j as default
};
